import React from 'react';
import { IconTrash, IconExclamationCircle } from '@tabler/icons-react';

export default function ConfirmDeleteModal({
    isOpen,
    onClose,
    onConfirm,
    title = 'Confirm Delete',
    message = 'Are you sure you want to delete this item? This action cannot be undone.',
    itemName = '',
    isLoading = false,
    confirmLabel = 'Delete Anyway',
    loadingLabel = 'Deleting...',
    confirmClassName = 'btn btn-danger flex-1 flex items-center justify-center gap-5',
    headerIcon = <IconTrash size={32} className="text-danger" />,
    headerIconBg = 'bg-danger/10',
}) {
    if (!isOpen) return null;

    return (
        <>
            <div className="fixed p-15 w-full max-w-[450px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[1000]">
                <div className='py-20 md:px-20 px-[15px] bg-bg-dark rounded-lg shadow-light border border-border'>
                    <div className="flex flex-col items-center text-center">
                        <div className={`w-60 h-60 rounded-full ${headerIconBg} flex items-center justify-center mb-20`}>
                            {headerIcon}
                        </div>

                        <h3 className="text-xl font-semibold mb-10">{title}</h3>

                        <div className="bg-bg-light p-15 rounded-lg border border-border/50 mb-20 w-full text-left">
                            <p className="text-sm text-text-secondary mb-10">
                                {message}
                            </p>
                        </div>

                        <div className="flex gap-10 w-full">
                            <button
                                type='button'
                                onClick={onClose}
                                className='btn btn-outline-secondary flex-1'
                                disabled={isLoading}
                            >
                                Cancel
                            </button>
                            <button
                                type='button'
                                onClick={onConfirm}
                                className={confirmClassName}
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <>
                                        <IconExclamationCircle className="animate-spin" size={18} />
                                        {loadingLabel}
                                    </>
                                ) : confirmLabel}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div
                onClick={onClose}
                className='fixed z-[999] w-full h-full left-0 top-0 bg-black/50 backdrop-blur-[3px]'
            ></div>
        </>
    );
}
